import styled from 'styled-components';
import Ico20 from '../Ico20';

type ButtonProps = {
  $color?: string;
};

export const Button = styled.button<ButtonProps>`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.$color || '#78909C'};
  border: 0;
  &:disabled {
    cursor: auto;
  }
`;

type IconProps = {
  $iconColor?: string;
};

export const Icon = styled(Ico20)<IconProps>`
  color: ${props => (props.$iconColor ? props.$iconColor : '#FFFFFF')};
`;
